import { curatedLists } from "@/mocks/editorial";
import SectionHeading from "./SectionHeading";

export default function CuratedLists() {
  return (
    <section id="curated" className="section-pad scroll-mt-20 bg-background-50">
      <div className="container-x">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="编辑精选"
            title="场景化片单，按心情挑"
            desc="不只按题材，更按场景与情绪整理片单。周末宅家、想大笑、想看硬核科幻，这里都有对应答案。"
          />
          <a
            href="#contact"
            className="inline-flex shrink-0 items-center gap-1 self-start text-sm font-semibold text-primary-700 hover:text-primary-800 md:self-auto"
          >
            求推荐新片单
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {curatedLists.map((c) => (
            <article key={c.id} className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition-transform duration-300 hover:-translate-y-1.5">
              <a href="#review" className="relative block overflow-hidden" aria-label={c.title}>
                <img
                  src={c.cover}
                  alt={c.title}
                  className="aspect-[3/2] w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent"></div>
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-white/90 px-2.5 py-1 text-xs font-bold text-primary-700 backdrop-blur-sm">
                  <i className="ri-play-list-2-fill" aria-hidden="true"></i>
                  {c.itemCount} 部影片
                </span>
                <p className="absolute bottom-3 left-4 right-4 font-heading text-lg font-black text-white drop-shadow">{c.title}</p>
              </a>
              <div className="flex flex-1 flex-col p-5">
                <p className="text-sm text-foreground-600 md:text-[13px]">{c.description}</p>
                <div className="mt-4 flex flex-wrap items-center gap-2 pt-1">
                  {c.tags.map((t) => (
                    <span key={t} className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">
                      {t}
                    </span>
                  ))}
                </div>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary-700">
                  查看完整片单
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}